import React from "react";
import moment from "moment";
const format1 = "YYYY-MM-DD"
export const UpdateDateColumnFormatter = (cellContent, row) => (
  <span>{moment(row.updated_at).format(format1)}</span>
);
export const CreateDateColumnFormatter = (cellContent, row) => (
 
  <span>{moment(row.created_at).format(format1)}</span>
);
